import React from "react";
import PlannedRouteMarker from "./LegendMarker/PlannedRouteMarker";
import ActualRouteMarker from "../../../../../mapComponents/Markers/NextStopCompliance/ActualRouteMarker";
import DeviationMarker from "./LegendMarker/DeviationMarker";
import PickupMarker from "./LegendMarker/PickupMarker";
import DeliveriesMarker from "../../../../../mapComponents/Markers/NextStopCompliance/DeliveriesMarker";

const MapLegendBlock = ({ classes, information, title, markerName, color="" }) => {
  const getLegendMarker = () => {
    switch (markerName) {
      case "PlannedRouteMarker":
        return PlannedRouteMarker;
      case "ActualRouteMarker":
        return ActualRouteMarker;
      case "DeviationMarker":
        return DeviationMarker;
      case "PickupMarker":
        return PickupMarker;
      case "DeliveriesMarker":
        return DeliveriesMarker;
    }
  };
  const LegendMarker = getLegendMarker();
  return (
    <div className={classes.details}>
      <div className={classes.pickupContainer}>
        <LegendMarker color={color} />
      </div>
      <div className={classes.detailsLabel}>
        <div className={classes.detailsHeader}>{title}</div>
        <div>{information}</div>
      </div>
    </div>
  );
};

export default MapLegendBlock;
